import communicationSdk from '@/utils/partnerSdk/communicationSdk';

const ACTION_MAP = {
  openModal: 'OpenModal',
  navigate: 'Navigate',
};

export const hasAction = (item) => Boolean(item?.action?.name);

export const isActionExternal = (item) => {
  if (!item?.action) return false;
  return item.action.name === 'navigate' && item.action.payload?.newTab === true;
};

export const isInPageNavigation = (item) => {
  if (!item?.action) return false;
  return item.action.name === 'navigate' && item.action.payload?.newTab !== true;
};

export const executeAction = (action) => {
  if (!action?.name) return;
  const sdkAction = ACTION_MAP[action.name];
  if (!sdkAction) {
    console.warn(`[PlatformNavigation] Unknown action: ${action.name}`);
    return;
  }
  communicationSdk(sdkAction, action.payload || {});
};
